import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { OperationType } from "common/constants/sm-constants";
import { applicantDashboardModel } from "common/models/page-models/applicants/applicant-dashboard/applicant-dashboard-data.model";
import { RouteEnvelope } from "common/models/utility-models/base-model";
import { GridParams } from "common/models/utility-models/list-utility.model";
import { BaseResolver } from "common/resolvers/core-resolvers/base-resolver";
import { SystemService } from "common/services/core-services/system.service";
import { applicantdashboardWidgetService } from "common/widget/applicant-dashboard/applicant-dashboard.service";

@Injectable({
    providedIn: 'root'
})
export class applicantDashboardResolver extends BaseResolver<applicantDashboardModel> {
    constructor(protected fs: applicantdashboardWidgetService, protected override router: Router, private ss: SystemService) {
        super(fs, router);
    }

    override manageState() {

        if (this.router.getCurrentNavigation().extras.state === undefined) {
            const envelope = new RouteEnvelope();
            envelope.type = OperationType.MULTIUTILITY;
            // envelope.transferData = new GridParams();
            return envelope;
        } else {
            return this.router.getCurrentNavigation().extras.state;
        }

    }
}